import { helper as buildHelper } from '@ember/component/helper';
import moment from 'moment';

export default buildHelper(([value], { emptyDateInPast = false } = {}) => {
  if (value == null) {
    return emptyDateInPast;
  }

  const now = moment();
  const compareDate = moment(value);
  return compareDate.diff(now, 'minutes') <= -1;
});
